import {useTranslations} from 'next-intl';

const useAdditionalTermsTabItems = () => {
  const t = useTranslations('legalAdditionalTerms.tabs');

  return [
    {
      text: t('serviceLevelAgreement'),
      value: 'service-level-agreement',
      child: true
    },
    {
      text: t('textingPolicy'),
      value: 'texting-policy',
      child: true
    }
  ];
};

export default useAdditionalTermsTabItems;
